import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Search } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const TYPE = { client: 'Client', lead: 'Lead', appointment: 'Visit' };

export const WorkspaceSearch = ({ headers }) => {
  const [q, setQ] = useState('');
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    const onKey = (e) => { if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); ref.current?.focus(); } };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);
  useEffect(() => {
    if (q.trim().length < 2) { setRows([]); return undefined; }
    const t = setTimeout(() => axios.get(`${API_URL}/api/admin/workspace-search`, { headers, params: { q } }).then((r) => setRows(r.data)).catch(() => setRows([])), 250);
    return () => clearTimeout(t);
  }, [q, headers]);
  const go = (r) => { setOpen(false); setQ(''); navigate(r.href); };
  return (
    <div className="relative hidden lg:block" data-testid="workspace-search">
      <label className="flex items-center gap-2 text-xs text-[#6f7264]">
        <Search className="h-3.5 w-3.5" />
        <input ref={ref} value={q} onChange={(e) => { setQ(e.target.value); setOpen(true); }} onFocus={() => setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 150)}
          onKeyDown={(e) => { if (e.key === 'Enter' && rows[0]) go(rows[0]); if (e.key === 'Escape') { setOpen(false); e.currentTarget.blur(); } }}
          placeholder="Search workspace" maxLength={80} className="w-40 lg:w-52 bg-transparent outline-none placeholder:text-[#6f7264]" data-testid="workspace-search-input" aria-label="Search clients, leads and visits" />
        <kbd className="text-[9px] whitespace-nowrap border border-[#dcded2] rounded px-1.5 py-0.5 bg-white">⌘ K</kbd>
      </label>
      {open && q.trim().length >= 2 && (
        <div className="absolute right-0 top-9 w-80 rounded-lg border border-[#e7e4db] bg-white shadow-lg z-50 max-h-96 overflow-y-auto" data-testid="workspace-search-results">
          {rows.length === 0 ? <p className="p-3 text-xs text-[#77776e]">No clients, leads or visits match.</p> : rows.map((r) => (
            <button key={`${r.type}-${r.id}`} type="button" onMouseDown={() => go(r)} className="w-full text-left px-3 py-2.5 hover:bg-[#f4f2ed] border-b border-[#ecebe4] last:border-0" data-testid={`workspace-search-result-${r.id}`}>
              <span className="text-[9px] font-bold tracking-wider text-[#8a8c80] mr-2">{TYPE[r.type].toUpperCase()}</span>
              <span className="text-xs font-semibold text-[#20211d]">{r.label}</span>
              {r.detail && <span className="block text-[11px] text-[#77776e] truncate">{r.detail}</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
